import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['buttons', 'form', 'input']

  open() {
    this.buttonsTarget.classList.add('hidden');
    this.formTarget.classList.remove('hidden');
    this.formTarget.classList.add('flex');
    this.inputTarget.focus();
  }

  close() {
    this.formTarget.classList.add('hidden');
    this.formTarget.classList.remove('flex');
    this.buttonsTarget.classList.remove('hidden');
    this.inputTarget.value = '';
  }
}
